var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalConstraints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.28363C6.48 2.28363 2 6.76363 2 12.2836C2 17.8036 6.48 22.2836 12 22.2836C17.52 22.2836 22 17.8036 22 12.2836C22 6.76363 17.52 2.28363 12 2.28363ZM4 12.2836C4 11.6736 4.08 11.0736 4.21 10.5036L8.99 15.2836V16.2836C8.99 17.3836 9.89 18.2836 10.99 18.2836V20.2136C7.06 19.7136 4 16.3536 4 12.2836ZM17.89 17.6836C17.63 16.8736 16.89 16.2836 15.99 16.2836H14.99V13.2836C14.99 12.7336 14.54 12.2836 13.99 12.2836H7.99V10.2836H9.99C10.54 10.2836 10.99 9.83363 10.99 9.28363V7.28363H12.99C14.09 7.28363 14.99 6.38363 14.99 5.28363V4.87363C17.92 6.05363 20 8.93363 20 12.2836C20 14.3636 19.19 16.2636 17.89 17.6836Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalConstraints);
export default __webpack_public_path__ + "static/media/global-constraints.83bc7d4ba948b0b678bd830324d8beda.svg";
export { ForwardRef as ReactComponent };